export type UnauthInternetChatLauncherModule = typeof import("./index");

export const loadUnauthInternetChatLauncher =
  (): Promise<UnauthInternetChatLauncherModule> => import("./index");
